import SearchBox from "../../../common_nextgen/common_components/SearchScreenComponents/SearchBox";  
import DisplayTable from "../../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";  
import ButtonsSection from "../../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";  
import NextGenPaginator from "../../../common_nextgen/common_components/Pagination/NextGenPaginator";  
import ConfirmationModal from "../../../common_nextgen/common_components/Modal/ConfirmationModal";  
import useCouponPatientPayGPIList from "./hooks/useCouponPatientPayGPIList";  
  
const CouponPatientPayGPILists = () => {  
  const couponPatientPayGPIListData = useCouponPatientPayGPIList();  
  
  return (  
    <div class="container container-fluid">  
    <ButtonsSection ctaButtons={couponPatientPayGPIListData.leftButtons} align="left"/>  
      <div className="header-section">  
        <h1>  
          {couponPatientPayGPIListData.screen_title} -{" "}  
          <span className="heading-cod">{couponPatientPayGPIListData.screenNumber}</span>  
        </h1>  
      </div>  
      <SearchBox  
        formFields={couponPatientPayGPIListData.formFields}  
        dropdownValues={couponPatientPayGPIListData.dropdownValues}  
        paramsData={couponPatientPayGPIListData.paramsData}  
        updataParamData={couponPatientPayGPIListData.updateParamData}  
      />  
      <ButtonsSection ctaButtons={couponPatientPayGPIListData.ctaButtons} />  
      <DisplayTable  
        data={couponPatientPayGPIListData.data}  
        parmKey={couponPatientPayGPIListData.parmKey}  
        menuOptions={couponPatientPayGPIListData.menuOptions}  
        tableHeaders={couponPatientPayGPIListData.columnDef}  
        setRowData={couponPatientPayGPIListData.setRowData}  
        selectedPriceSchedules={couponPatientPayGPIListData.selectedRows}  
        setSelectedPriceSchedules={couponPatientPayGPIListData.setSelectedRows}  
      />  
      <div className="paginator-container">  
        <NextGenPaginator  
          first={couponPatientPayGPIListData.first}  
          rows={couponPatientPayGPIListData.rows}  
          totalRecords={couponPatientPayGPIListData.totalRecords}  
          currentPage={couponPatientPayGPIListData.currentPage}  
          rowsPerPageOptions={[10, 25, 50]}  
          onPageChange={couponPatientPayGPIListData.onPageChange}  
        />  
      </div>  
      {couponPatientPayGPIListData.isConfirmationModalOpen && (  
        <ConfirmationModal  
          isOpen={couponPatientPayGPIListData.isConfirmationModalOpen}  
          onRequestClose={couponPatientPayGPIListData.closeConfirmationModal}  
          onBack={couponPatientPayGPIListData.closeConfirmationModal}  
          onSave={couponPatientPayGPIListData.deletePriceSchedule}  
          confirmLabel="Confirm(Y/N)"  
          options={[  
            { label: "N-No", value: "no" },  
            { label: "Y-Yes", value: "yes" },  
          ]}  
          setSelectedOption={couponPatientPayGPIListData.setSelectedOption}  
        />  
      )}  
    </div>  
  );  
};  
  
export default CouponPatientPayGPILists;  